"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _APCryptoAddressInputComponent = _interopRequireDefault(require("./APCryptoAddressInputComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = (0, _reactRedux.connect)()(_APCryptoAddressInputComponent["default"]);